import type { PaymentPageData } from '@/types/onlineBooking';

export interface StripeRailPresentation {
  railsKnown: boolean;
  cardOnly: boolean;
  cardOffered: boolean;
  achOrCheckOffered: boolean;
}

export function stripeRailPresentation(
  acceptedMethods?: PaymentPageData['acceptedMethods'],
): StripeRailPresentation {
  // A cached payload created before acceptedMethods existed does not tell us
  // which rails its Payment Element exposes. Keep that uncertainty explicit
  // so the page does not advertise either rail until Stripe confirms a choice.
  if (acceptedMethods == null) {
    return {
      railsKnown: false,
      cardOnly: false,
      cardOffered: false,
      achOrCheckOffered: false,
    };
  }

  const cardOffered = acceptedMethods.includes('card');
  const achOrCheckOffered = acceptedMethods.includes('ach');

  return {
    railsKnown: true,
    cardOnly: cardOffered && acceptedMethods.length === 1,
    cardOffered,
    achOrCheckOffered,
  };
}
